import { render, staticRenderFns } from "./LegoControlCardEffort.vue?vue&type=template&id=dd0bbd66&scoped=true"
import script from "./LegoControlCardEffort.vue?vue&type=script&lang=js"
export * from "./LegoControlCardEffort.vue?vue&type=script&lang=js"
import style0 from "./LegoControlCardEffort.vue?vue&type=style&index=0&id=dd0bbd66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0bbd66",
  null
  
)

export default component.exports